export default __webpack_public_path__ + "static/media/fullscreen-top-mobile.5cc19bc7.jpg";